// Shared destructive-action confirmation dialog.
// Usage: const [confirm, setConfirm] = useState(null);
//        setConfirm({ title, detail, run: async () => {...} });
//        <ConfirmDialog confirm={confirm} onClose={() => setConfirm(null)} />
export function ConfirmDialog({ confirm, onClose }) {
  if (!confirm) return null;
  const handleConfirm = async () => {
    await confirm.run();
    onClose();
  };
  return (
    <div
      className="fixed inset-0 bg-[#1A1F16]/70 z-[70] flex items-center justify-center p-6"
      onClick={onClose}
      data-testid="confirm-dialog"
    >
      <div onClick={(e) => e.stopPropagation()} className="bg-[#F7F5F0] border border-[#1A1F16] p-8 w-full max-w-sm">
        <h3 className="font-serif text-3xl tracking-tight" data-testid="confirm-dialog-title">{confirm.title}</h3>
        <p className="text-sm text-[#6C7565] mt-3" data-testid="confirm-dialog-detail">{confirm.detail}</p>
        <div className="flex gap-3 mt-8">
          <button
            type="button"
            data-testid="confirm-cancel-btn"
            onClick={onClose}
            className="flex-1 border border-[#1A1F16] py-3 text-xs uppercase tracking-widest hover:bg-[#EAE7DD]"
          >
            Cancel
          </button>
          <button
            type="button"
            data-testid="confirm-delete-btn"
            onClick={handleConfirm}
            className="flex-1 bg-[#D94F3D] text-white py-3 text-xs uppercase tracking-widest hover:bg-[#B8402F]"
          >
            {confirm.confirmLabel || "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
